export const setLaravelErrors = (errors, setErrors) => {
  const errorKeys = Object.keys(errors);
  let errorFields = {};
  errorKeys.map(function(errorKey) {
    errorFields[errorKey] = errors[errorKey][0];
  });
  console.log(errorFields);
  setErrors(errorFields);
};

export const setLaravelTypeArrayErrors = (errors, setErrors) => {
  const errorKeys = Object.keys(errors);
  let errorFields = [];
  errorKeys.map(function(errorKey, key) {
    errorFields[key] = errors[errorKey][0];
  });
  //   console.log(errorFields);
  setErrors({ errorarray: errorFields });
};
